import ProjectCommons from '../project-commons';
import {ProjectSettingsPrivada} from '../project-settings-privada';
import {fillContentPrivadaModalsMobile, isEmail} from '../utils.esm';
import {isMobileDevice} from "../platform";

class GuestPage {
    constructor() {
        console.log('init GuestPage');

        new ProjectCommons();
        window.projectSettings = new ProjectSettingsPrivada(window.projectSettingsParams);

        this.loadLoginOpenedModal();
        this.eventsLoginModals();
    }

    loadLoginOpenedModal() {
        if(window.location.hash === '#login')
            this.openModal('/#login', 2, '#modalLogin');
        else if(window.location.hash === '#create-account')
            this.openModal('/#create-account', 1, '#modalCreateAccount');
        else if(window.location.hash === '#reset-password')
            this.openModal('/#reset-password', 2, '#modalResetPassword');
        else if(window.location.hash === '#login-options')
            this.openModal('/#login-options', 1, '#modalLoginOptions');
        else if(window.location.hash === '#success-reset-password') {
            document.querySelector('#modalResetPassword .card-body').classList.add('success');
            this.openModal('/#reset-password', 2, '#modalResetPassword');
        }

        window.location.hash = '';
    }

    eventsLoginModals() {
        const caBtns = document.querySelectorAll('a.create-account');
        const loginBtns = document.querySelectorAll('a.login');
        const modals = document.querySelectorAll('#modalLogin, #modalResetPassword, #modalCreateAccount, #modalLoginOptions, #modalLoginNoPassword');
        const noPasswordEmailInputs = document.querySelectorAll('#modalLoginNoPassword #email-no-password');

        const url = '/';
        history.pushState({url, level: 0}, document.title, url);

        window.addEventListener('popstate', () => {
            const hasProp = history.state && history.state.hasOwnProperty('url');
            if(!hasProp || history.state.level === 0) $('.modal').modal('hide');
            else if(hasProp && history.state.url.endsWith('#login-options')) this.openModal('/#login-options', 1, '#modalLoginOptions', false);
        });

        if(caBtns.length > 0)
            Array.from(caBtns).forEach((caBtn) =>
                caBtn.addEventListener('click', () =>
                    this.openModal('/#create-account', 1, '#modalCreateAccount')));
        if(loginBtns.length > 0)
            Array.from(loginBtns).forEach((loginBtn) =>
                loginBtn.addEventListener('click', () =>
                    this.openModal('/#login-options', 1, '#modalLoginOptions')));
        if(modals.length > 0)
            Array.from(modals).forEach((modal) =>
                $(modal).on('hide.bs.modal', this.closeLoginPageModals));
        if(noPasswordEmailInputs.length > 0)
            Array.from(noPasswordEmailInputs).forEach((input) =>
                input.addEventListener('keyup', this.noPasswordInputKeyupHandler));
    }

    openModal(url, historyLevel, selector, pushState = true) {
        $('html, body').scrollTop(0);
        setTimeout(() => {
            history.pushState({url, level: historyLevel}, document.title, url);

            if(pushState)
                $('.modal').modal('hide');

            if(isMobileDevice && !document.querySelector(`${selector} #advantageSection`))
                fillContentPrivadaModalsMobile(selector);

            document.body.classList.add('block-scroll');

            $(selector).modal('show');
            window.pullMenu();
        }, 0);
    }

    closeLoginPageModals() {
        document.body.classList.remove('block-scroll');
    }

    noPasswordInputKeyupHandler(event) {
        const target = event.target;
        const btn = document.querySelector('#modalLoginNoPassword #btnEnterErosguia');
        const email = document.querySelector('#email-no-password').value;
        if(target.value.length !== 0 && isEmail(email)) btn.removeAttribute('disabled');
        else btn.setAttribute('disabled', 'true');
    }

    closeModal(selector, extra = false) {
        if(extra)
            document.querySelector(`${selector} .card-body`).classList.remove('success');

        $(selector).modal('hide');
    }

    loginNoPassword(event) {
        event.preventDefault();
        event.stopPropagation();

        const email = document.querySelector('#email-no-password').value;
        document.querySelector('#modalLoginNoPassword .text-no-password span').innerHTML = email;
        document.querySelector('#modalLoginNoPassword .card-body').classList.add('success');

        $.ajax({
            type: 'POST',
            dataType: 'json',
            async: true,
            url: `${window.HTML_ROOT}/send-login-no-password`,
            data: { email },
        });
    }

}

window.guestPage = new GuestPage();